import templateUrl from "emun.order/order-enter-creditcard.htm";
import OrderEnterCreditcardController from "emun.order/order-enter-creditcard.controller";
import open from "webmodals/open";

let OrderEnterCreditcard = options => {
  let modalInstance = open({
    size: options.size || "xl",
    templateUrl: options.templateUrl || templateUrl,
	  controller: OrderEnterCreditcardController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default OrderEnterCreditcard;
